// Communications
const MeetingsPage = () => import('@pages/communications/meetings/MeetingsPage')

const MeetingRoom = () => import('@pages/communications/meetings/MeetingRoom')

const WaitingRoom = () => import('@pages/communications/meetings/WaitingRoom')

import authGuard from '../authGuard'

export default {
    path: '/meetings-place',
    component: MeetingsPage,
    children: [
        {
            path: 'meeting-room',
            component: MeetingRoom,
            name: 'meetingRoom',
        },
        {
            path: 'waiting-room',
            component: WaitingRoom,
            name: 'waitingRoom',
        },
    ],
    beforeEnter: authGuard,
}
